import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { redirectToLogin } from "../utils/auth";
import { getAccessToken } from "../utils/token";
import { rootRoute } from "./root";

export const updatePaymentRoute = createRoute({
  path: "/$locale/update-payment/$hash",
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import("../pages/update-payment")),
  beforeLoad: () => {
    if (!getAccessToken()) {
      redirectToLogin();
    }
  },
});
